'use client';

import mobileBanner from '@/assets/images/wedding-accessories/banner-m.jpg';
import banner from '@/assets/images/wedding-accessories/banner.jpg';
import CutOffText from '@/components/CutOffText';
import LoadingIndicator from '@/components/LoadingIndicator';
import useIsMobile from '@/hooks/use-is-mobile';
import { useWeddingAccessoriesPage } from '@/hooks/WeddingAccessoriesPage/useWeddingAccessoriesPage';
import parse from 'html-react-parser';
import Image from 'next/image';
import Link from 'next/link';
import AccessoryItem from './accessoryItem';
import classes from './weddingAccessoriesPage.module.css';

export const WeddingAccessoriesPage = () => {
  const talonProps = useWeddingAccessoriesPage({});

  const { items, loading } = talonProps;

  const isMobile = useIsMobile();

  if (loading) {
    return <LoadingIndicator>loading...</LoadingIndicator>;
  }

  const cutOffLength = isMobile ? 100 : 150;

  const itemsContent = items.map((item, index) => {
    const { products, description } = item;

    const title = description.match(/<h5>.+<\/h5>/g)[0];

    const contentText = description
      .replace(/<h5>.+<\/h5>/g, '')
      .replace(/<\/?.+?>/g, '')
      .replace(/\n/g, '');

    const rowClass = index % 2 === 0 ? classes.row : classes.reverseRow;

    const contentContainerClass = index % 2 === 0 ? classes.contentContainer : classes.reverseContentContainer;

    const contentTextClass = index % 2 === 0 ? classes.contentText : classes.reverseContentText;

    return (
      <div key={index}>
        <div className={rowClass}>
          <div className={classes.content}>
            <div className={contentContainerClass}>
              {parse(title)}
              <p className={contentTextClass}>
                <CutOffText
                  text={contentText}
                  length={cutOffLength}
                />
              </p>
              <a
                className={classes.contentLink}
                href={item.url}
              >
                shop now
              </a>
            </div>
          </div>
          <div className={classes.image}>
            {item.imgurl && (
              <img
                src={item.imgurl}
                alt=''
              />
            )}
          </div>
        </div>
        <div className={classes.productList}>
          {products.map((product, index) => (
            <AccessoryItem
              product={product}
              key={index}
            />
          ))}
        </div>
      </div>
    );
  });

  return (
    <div className={classes.root}>
      <div className={classes.bannerContainer}>
        <Image
          className={classes.banner}
          src={banner}
          alt=''
        />
        <Image
          className={classes.mobileBanner}
          src={mobileBanner}
          alt=''
        />
      </div>
      <h2 className={classes.title}>Wedding Accessories</h2>
      {itemsContent}

      <div className={classes.viewAllContainer}>
        <Link href='/wedding-accessories-list'>View All</Link>
      </div>
    </div>
  );
};

export default WeddingAccessoriesPage;
